export default "__VITE_ASSET__dcx3CBt1__"